import { render, staticRenderFns } from "./UserLogin.vue?vue&type=template&id=49bbb3d6"
import script from "./UserLogin.vue?vue&type=script&lang=js"
export * from "./UserLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49bbb3d6')) {
      api.createRecord('49bbb3d6', component.options)
    } else {
      api.reload('49bbb3d6', component.options)
    }
    module.hot.accept("./UserLogin.vue?vue&type=template&id=49bbb3d6", function () {
      api.rerender('49bbb3d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/User/UserLogin.vue"
export default component.exports